import { jsx } from "react/jsx-runtime";
import { RouteManagerLogo } from "./logos/RouteManagerLogo.js";
import { RouteManagerLogoContrast } from "./logos/RouteManagerLogoContrast.js";
import { RouteManagerLogoIcon } from "./logos/RouteManagerLogoIcon.js";
import { RouteManagerLogoIconContrast } from "./logos/RouteManagerLogoIconContrast.js";
import { RouteManagerLogoStacked } from "./logos/RouteManagerLogoStacked.js";
import { RouteManagerLogoStackedContrast } from "./logos/RouteManagerLogoStackedContrast.js";
function RouteManager(props) {
  const { variant = "normal", mode = "normal", ...svgProps } = props;
  switch (variant) {
    case "normal":
      return mode === "contrast" ? /* @__PURE__ */ jsx(RouteManagerLogoContrast, { ...svgProps }) : /* @__PURE__ */ jsx(RouteManagerLogo, { ...svgProps });
    case "stacked":
      return mode === "contrast" ? /* @__PURE__ */ jsx(RouteManagerLogoStackedContrast, { ...svgProps }) : /* @__PURE__ */ jsx(RouteManagerLogoStacked, { ...svgProps });
    case "icon":
      return mode === "contrast" ? /* @__PURE__ */ jsx(RouteManagerLogoIconContrast, { ...svgProps }) : /* @__PURE__ */ jsx(RouteManagerLogoIcon, { ...svgProps });
    default:
      return null;
  }
}
export {
  RouteManager
};
//# sourceMappingURL=RouteManager.js.map
